module.exports = __webpack_public_path__ + "images/directory/featured-hero/slack@2x.1343ac057b930a36d33a.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/slack@2x.jpg
// module id = A8jf
// module chunks = 2